<div class="bh-faq">
  <h2 class="bh-faq-title">Frequently Asked Questions</h2>
  <div class="bh-faq-list">
    <ng-container *ngFor="let faq of interface.list | random | slice: 0: 5; let f = index">
      <details>
        <summary>
            {{faq.question}}
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 action-plus" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 action-minus" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
            </svg>
        </summary>
        <div>
          <div>{{faq.answer}}</div>
        </div>
      </details>
    </ng-container>
  </div>
</div>
